module.exports = __webpack_public_path__ + "media/components/assets/icons/confirm_success-ec63c3b2852f47db2a85a32b2827d1e9.svg";